// extracted by mini-css-extract-plugin
export default {"link":"ThemeCardsLine__link--slots-sS_0f","card":"ThemeCardsLine__card--slots-jx4wX"};